<template>
    <div>
        <menu-bar/>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"> <i class="fa fa-home" aria-hidden="true"></i>INICIAL</a></li>
                    <li class="active"><i class="fa fa-id-card-o" aria-hidden="true"></i> CONDOMÍNIOS</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <menu-condominio/>
                    </div>
                    <div class="col-md-9">

                        <div class="row">
                            <div class="col-md-7">
                                <label class="control-label">BUSCA POR NOME DO CONDOMÍNIO</label>
                                <input type="text" v-model="nome" class="form-control">
                            </div>

                            <div class="col-md-5">
                                <br/>
                                <blockquote class="blockquote-reverse">
                                    Total de Condomínios: <b>{{ getContratos.length }}</b>
                                </blockquote>
                            </div>

                            <div class="col-md-12" style="margin-top: 20px">

                                <table id="mytable" class="table table-bordred table-striped">

                                    <thead>
                                        <tr>
                                            <th>CLIENTE</th>
                                            <th style="text-align: center;width: 100px">AÇÕES</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr v-for="r in getContratos" v-bind:key="r._id">
                                            <td style="vertical-align: middle; text-transform: uppercase">{{ r.nome }}</td>
                                            <td style="text-align: center">
                                                <a :href="'#/condominio/' + r._id" class="btn btn-primary btn-xs">
                                                    ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                                </a>
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MenuCondominio from "../../menus/condominio";
import { Condominios } from "../../class/condominios";

export default {
    components: {
        MenuCondominio
    },
    data() {
        return {
            contratos: [],
            user: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome) {
                return this.contratos;
            }

            return this.contratos.filter(player => {
                return player.nome
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.load();
    },
    methods: {
        async load() {
            this.contratos = await Condominios.all();
        }
    }
};
</script>
